export const GET_PRODUCT_COUNTDOWN_TIMER = 'GET_PRODUCT_COUNTDOWN_TIMER';

export const GET_PRODUCT_COUNTDOWN_TIMER_SUCCESS = 'GET_PRODUCT_COUNTDOWN_TIMER_SUCCESS';

export const GET_PRODUCT_COUNTDOWN_TIMER_FAILED = 'GET_PRODUCT_COUNTDOWN_TIMER_FAILED';
